<div class="landing-page-container">
  <div class="landing-right-col">
    <ng-container *ngIf="viewMode === 'projects'; else featureView">

      <section *ngIf="favoriteProjects.length > 0" class="projects-section favorites-section">
        <div class="favorites-heading">
          <fa-icon [icon]="faStar" class="favorites-star"></fa-icon>
          <h1>Favorites</h1>
          <span class="favorites-meta">{{ favoriteProjects.length }} PINNED · QUICK ACCESS</span>
        </div>
        <div class="favorites-scroller">
          <project-thumbnail
            *ngFor="let fav of favoriteProjects"
            [project]="fav"
            [userRoles]="userRoles"
            [cardMetrics]="cardMetricsById[fav.ProjectId]"
            [metricsLoading]="isCardMetricsPlaceholder(fav.ProjectId)"
            layout="favorite"
            (favoriteToggled)="onToggleFavorite($event)">
          </project-thumbnail>
        </div>
      </section>

      <section class="projects-section portfolio-section">
        <div class="filters-bar">
          <div class="combo-select" [class.open]="clientMenuOpen">
            <button type="button" class="combo-select__button" (click)="toggleClientMenu($event)">
              <span class="combo-select__label">CLIENT</span>
              <span class="combo-select__value">{{ selectedClientLabel }}</span>
              <span class="combo-select__chevron"></span>
            </button>
            <div class="combo-select__menu" *ngIf="clientMenuOpen" (click)="$event.stopPropagation()">
              <button type="button" class="combo-select__option" [class.selected]="isAllClientsSelected"
                (click)="chooseClient(0)">All Clients</button>
              <button type="button" class="combo-select__option" *ngFor="let client of clientList"
                [class.selected]="isClientOptionSelected(client)"
                (click)="chooseClient(client)">{{ client.Name }}</button>
            </div>
          </div>

          <div class="combo-select" [class.open]="assetMenuOpen">
            <button type="button" class="combo-select__button" (click)="toggleAssetMenu($event)">
              <span class="combo-select__label">ASSET</span>
              <span class="combo-select__value">{{ selectedAssetLabel }}</span>
              <span class="combo-select__chevron"></span>
            </button>
            <div class="combo-select__menu" *ngIf="assetMenuOpen" (click)="$event.stopPropagation()">
              <button type="button" class="combo-select__option" [class.selected]="isAllAssetsSelected"
                (click)="chooseAsset(0)">All Assets</button>
              <button type="button" class="combo-select__option" *ngFor="let asset of assetList"
                [class.selected]="isAssetOptionSelected(asset)"
                (click)="chooseAsset(asset)">{{ asset.Name }}</button>
            </div>
          </div>

          <div class="search-field">
            <fa-icon [icon]="faSearch" class="search-field__icon"></fa-icon>
            <input type="text"
                   [formControl]="projectSearchControl"
                   (input)="onProjectSearchChange()"
                   placeholder="Search projects..." />
          </div>

          <div class="filters-bar__end">
            <select [formControl]="projectSortControl"
                    (change)="projectSortChanged()"
                    class="sort-select">
              <option value="latest-desc">Latest Projects</option>
              <option value="latest-asc">Oldest Projects</option>
              <option value="client-name-az">Client Name A–Z</option>
              <option value="client-name-za">Client Name Z–A</option>
              <option value="asset-name-az">Asset Name A–Z</option>
              <option value="asset-name-za">Asset Name Z–A</option>
              <option value="name-az">Project Name A–Z</option>
              <option value="name-za">Project Name Z–A</option>
            </select>
            <div class="project-type-options">
              <label>
                <input type="radio" name="activeProjectsSelected" value="active"
                       (change)="onProjectTypeChange('active')" [ngModel]="activeProjectsSelected" />
                Active
              </label>
              <label>
                <input type="radio" name="activeProjectsSelected" value="inactive"
                       (change)="onProjectTypeChange('inactive')" [ngModel]="activeProjectsSelected" />
                Inactive
              </label>
              <label>
                <input type="radio" name="activeProjectsSelected" value="all"
                       (change)="onProjectTypeChange('all')" [ngModel]="activeProjectsSelected" />
                All
              </label>
            </div>
          </div>
        </div>

        <div class="portfolio-heading-row">
          <h1 class="portfolio-title">Your Project Portfolio</h1>
          <p class="portfolio-sub">
            <ng-container *ngIf="isLoadingProjects">Loading projects…</ng-container>
            <ng-container *ngIf="!isLoadingProjects">{{ totalCount || 0 }} projects · entitlements scoped by client</ng-container>
          </p>
        </div>

        <div *ngIf="isLoadingProjects" class="portfolio-loading" role="status" aria-live="polite">
          <div class="portfolio-loading__status">
            <fa-icon [icon]="faSpinner" [spin]="true"></fa-icon>
            <span>Loading projects…</span>
          </div>
          <div class="project-skeleton-grid">
            <div class="project-skeleton-card" *ngFor="let card of projectSkeletonCards">
              <div class="project-skeleton-card__line shimmer"></div>
              <div class="project-skeleton-card__title shimmer"></div>
              <div class="project-skeleton-card__pill shimmer"></div>
              <div class="project-skeleton-card__metrics">
                <div class="project-skeleton-card__metric shimmer" *ngFor="let metric of [1,2,3,4]"></div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!isLoadingProjects && totalCount === 0" class="empty-state">No Projects to display.</div>

        <div id="project-list" class="project-list-scroll" *ngIf="!isLoadingProjects && projects?.length > 0">
          <project-list
            [projects]="pagedProjects"
            [clientCount]="clientCount"
            [userRoles]="userRoles"
            [cardMetricsById]="cardMetricsById"
            [metricsPendingById]="metricsPendingById"
            (favoriteToggled)="onToggleFavorite($event)">
          </project-list>
        </div>

        <div class="portfolio-footer" *ngIf="totalCount > 0">
          <div class="page-size-control">
            <label for="page-size-select">Show</label>
            <select id="page-size-select"
                    [formControl]="pageSizeControl"
                    (change)="onPageSizeChange()"
                    class="form-control form-control-sm page-size-select">
              <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
              <option [ngValue]="0">All</option>
            </select>
            <span>per page</span>
          </div>

          <nav class="pagination-nav" aria-label="Projects pagination" *ngIf="showPagination">
            <button type="button" class="page-btn" (click)="goToPage(currentPage - 1)"
                    [disabled]="currentPage <= 1" aria-label="Previous page">
              <fa-icon [icon]="faChevronLeft"></fa-icon>
            </button>

            <ng-container *ngFor="let page of visiblePages">
              <span *ngIf="page === '...'" class="page-ellipsis">…</span>
              <button *ngIf="page !== '...'" type="button" class="page-btn"
                      [class.active]="page === currentPage"
                      (click)="goToPage(+page)">
                {{ page }}
              </button>
            </ng-container>

            <button type="button" class="page-btn" (click)="goToPage(currentPage + 1)"
                    [disabled]="currentPage >= totalPages" aria-label="Next page">
              <fa-icon [icon]="faChevronRight"></fa-icon>
            </button>

            <span class="page-status">Page {{ currentPage }} of {{ totalPages }}</span>
          </nav>

          <div class="showing-count">
            Showing {{ showingFrom }} - {{ showingTo }} of {{ totalCount }} projects
          </div>
        </div>
      </section>
    </ng-container>

    <ng-template #featureView>
      <div class="feature-view-container" *ngIf="!isFeatureDetail">
        <feature-releases></feature-releases>
      </div>
      <div class="feature-view-container" *ngIf="isFeatureDetail">
        <feature-release-detail></feature-release-detail>
      </div>
    </ng-template>
  </div>
</div>
